export default Object.freeze({
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  Critical: 'max',
});
